import { chain, find, isEqual, isNil, includes, get } from 'lodash';

import { IQohInventoryItemVenue } from '@app/shared/types/entities/transfer/transfer.type';
import { EntityId } from '@app/shared/types';

import { PredicateShowsItemFunction } from './tiny-transfer.types';

export const getShowingItemsFilter: (
  showAll: boolean,
  alwaysShowingItems?: EntityId[],
) => PredicateShowsItemFunction<IQohInventoryItemVenue> =
  (
    showAll,
    alwaysShowingItems,
  ): PredicateShowsItemFunction<IQohInventoryItemVenue> =>
  (totalItems, grid): IQohInventoryItemVenue[] => {
    const gridItems = get(
      grid,
      'field.control.value',
    ) as IQohInventoryItemVenue[];

    const showingItems = chain(totalItems)
      .map((item) => {
        const gridChangedItem = find(
          gridItems,
          (gridItem) =>
            isEqual(gridItem.entity_id, item.entity_id) &&
            !isNil(gridItem.initial_count),
        );

        if (!isNil(gridChangedItem)) {
          return gridChangedItem;
        }

        if (showAll) {
          return item;
        }

        return includes(alwaysShowingItems, item.entity_id) ? item : null;
      })
      .compact()
      .value();

    return showingItems;
  };
